(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function init(root) {
    if (!root || root.getAttribute("data-kps-init") === "1") return;
    root.setAttribute("data-kps-init", "1");

    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-kps-slide]"));
    if (!slides.length) return;

    var idx = 0;

    function showSlide(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) {
        var on = j === idx;
        s.classList.toggle("is-active", on);
        s.setAttribute("aria-hidden", on ? "false" : "true");
      });
    }

    root.querySelectorAll("[data-kps-slide-prev]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        showSlide(idx - 1);
      });
    });
    root.querySelectorAll("[data-kps-slide-next]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        showSlide(idx + 1);
      });
    });

    slides.forEach(function (slide) {
      slide.querySelectorAll("[data-kps-tab]").forEach(function (tab) {
        tab.addEventListener("click", function () {
          var t = tab.getAttribute("data-kps-tab");
          slide.querySelectorAll("[data-kps-tab]").forEach(function (x) {
            var on = x === tab;
            x.classList.toggle("is-active", on);
            x.setAttribute("aria-selected", on ? "true" : "false");
          });
          slide.querySelectorAll(".kps__panel[data-kps-panel]").forEach(function (p) {
            var match = p.getAttribute("data-kps-panel") === t;
            p.classList.toggle("is-active", match);
            p.setAttribute("aria-hidden", match ? "false" : "true");
          });
          slide.querySelectorAll("[data-kps-gallery]").forEach(function (g) {
            var match = g.getAttribute("data-kps-panel") === t;
            g.classList.toggle("is-active", match);
          });
        });
      });

      slide.querySelectorAll("[data-kps-gallery]").forEach(function (gal) {
        var main = gal.querySelector("[data-kps-main]");
        if (!main) return;
        gal.querySelectorAll(".kps__thumb").forEach(function (thumb) {
          thumb.addEventListener("click", function () {
            var src = thumb.getAttribute("data-full-src");
            if (src) main.setAttribute("src", src);
            gal.querySelectorAll(".kps__thumb").forEach(function (b) {
              b.classList.remove("is-active");
            });
            thumb.classList.add("is-active");
          });
        });
      });

      slide.querySelectorAll("[data-kps-variant-select]").forEach(function (sel) {
        sel.addEventListener("change", function () {
          var opt = sel.options[sel.selectedIndex];
          var price = opt.getAttribute("data-price");
          var panel = sel.closest(".kps__panel");
          if (panel && price) {
            var prEl = panel.querySelector("[data-kps-price]");
            if (prEl) prEl.textContent = price;
          }
        });
      });

      slide.querySelectorAll("[data-kps-qty-minus]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var wrap = btn.closest("[data-kps-qty]");
          var inp = wrap && wrap.querySelector('input[name="quantity"]');
          if (!inp) return;
          var v = Math.max(1, parseInt(inp.value, 10) || 1);
          inp.value = String(Math.max(1, v - 1));
        });
      });
      slide.querySelectorAll("[data-kps-qty-plus]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var wrap = btn.closest("[data-kps-qty]");
          var inp = wrap && wrap.querySelector('input[name="quantity"]');
          if (!inp) return;
          var max = parseInt(inp.getAttribute("max"), 10);
          var v = Math.max(1, parseInt(inp.value, 10) || 1);
          var next = v + 1;
          if (!isNaN(max) && max > 0) next = Math.min(next, max);
          inp.value = String(next);
        });
      });

      slide.querySelectorAll("[data-kps-buy-now]").forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          var form = btn.closest("form");
          if (!form) return;
          var fd = new FormData(form);
          fetch("/cart/add.js", {
            method: "POST",
            body: fd,
            headers: { Accept: "application/json" },
          })
            .then(function (r) {
              if (!r.ok) throw new Error("add failed");
              window.location.href = "/checkout";
            })
            .catch(function () {
              form.submit();
            });
        });
      });
    });

    showSlide(0);
  }

  ready(function () {
    document.querySelectorAll("[data-kayu-product-showcase]").forEach(init);
  });

  document.addEventListener("shopify:section:load", function (ev) {
    var sec = ev.target && ev.target.querySelector && ev.target.querySelector("[data-kayu-product-showcase]");
    if (sec) {
      sec.removeAttribute("data-kps-init");
      init(sec);
    }
  });
})();
